export default "__VITE_ASSET__CVM$NWRV__";